import { IonPage, IonRouterOutlet, getPlatforms } from "@ionic/react";
import { useContext, useEffect, useState } from "react";
import { Redirect, Route, Switch } from "react-router";
import isAuthenticated from "../../global/utils/isAuthenticated";
import { PortalProvider } from "../context/Provider";
import GlobalInitializeData from "../GlobalInitializeData";
import PaginaNoEncontrada from "../pages/PaginaNoEncontrada/PaginaNoEncontrada";
import AutocheckinContainer from "../_-_Autocheckin";
import routes from "./listRoutes";
import { GlobalContext } from "global/context/Provider";

const RouterPortal = () => {
  const { configState } = useContext(GlobalContext);

  const [routesLeidas, setRoutesLeidas] = useState(false);
  let path = window.location.pathname;

  useEffect(() => {
    setRoutesLeidas(true);
  }, []);

  return (
    <>
      {routesLeidas && (
        <PortalProvider>
          <GlobalInitializeData>
            <IonPage>
              <IonRouterOutlet>
                <Switch>
                  {routes.map((route, key) => {
                    if (
                      route.path.toLocaleLowerCase() ===
                      path.toLocaleLowerCase()
                    ) {
                      document.title = route.title;
                    }
                    return (
                      <Route
                        path={route.path}
                        key={key}
                        render={(props) =>
                          route.needsAuth &&
                          !isAuthenticated() &&
                          path !== "/" ? (
                            <Redirect to="/" />
                          ) : (
                            <route.component {...props} />
                          )
                        }
                        exact
                      />
                    );
                  })}

                  {/* Aca debe ir las rutas de autocheckin */}
                  <Route
                    path={"/autocheckin"}
                    component={AutocheckinContainer}
                  />
                  <Route
                    path={"/autocheckinDesktop"}
                    component={AutocheckinContainer}
                  />

                  {/*  Aca debe ir la ruta 404  */}
                  <Route path="*" component={PaginaNoEncontrada} />
                </Switch>
              </IonRouterOutlet>
            </IonPage>
          </GlobalInitializeData>
        </PortalProvider>
      )}
    </>
  );
};

export default RouterPortal;
